import React from "react";
import { useNavigate } from "react-router-dom";
import "./AppCardEvente.css";

export default function AppCardEvente({
  img,
  desc,
  descripcion,
  onClick,
  eventoId,
  fecha,
  lugar,
  hora,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (eventoId) {
      navigate(`/eventos/${eventoId}`);
    } else if (onClick) {
      onClick();
    }
  };

  const plainDesc = descripcion
    ? descripcion.replace(/<[^>]+>/g, "").trim()
    : "";

  const hasMeta = fecha || lugar || hora;

  return (
    <div className="event-card">
      <img src={img} alt={desc} className="event-img" />
      <div className="event-body">
        {desc && <p className="event-desc">{desc}</p>}
        {hasMeta && (
          <div className="event-meta">
            {fecha && <span className="event-meta__item">{fecha}</span>}
            {lugar && <span className="event-meta__item">{lugar}</span>}
            {hora && <span className="event-meta__item">{hora}</span>}
          </div>
        )}
        {plainDesc && <p className="event-subdesc">{plainDesc}</p>}
        <button className="event-btn" onClick={handleClick}>
          Ver más
        </button>
      </div>
    </div>
  );
}
